import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-dispos',
  templateUrl: './dispos.component.html',
  styleUrls: ['./dispos.component.scss']
})
export class DisposComponent implements OnInit {
  @ViewChild('dispoTable') table: any;

  rows: any[] = [];
  temp: any[] = [];
  selected: any[] = [];

  // Define columns for the datatable
  columns = [
    { name: 'Date', prop: 'date' },
    { name: 'Company', prop: 'company' },
    { name: 'Caller', prop: 'caller' },
    { name: 'Campaign', prop: 'campaign' },
    { name: 'Contact', prop: 'contact' },
    { name: 'Phone', prop: 'phone' },
    { name: 'Dispo', prop: 'dispo' },
    { name: 'Dispo Time', prop: 'dispoTime' },
    { name: 'Call Time', prop: 'callTime' },
    { name: 'Call Length', prop: 'callLength' },
    { name: 'Status', prop: 'status' },
    { name: 'User', prop: 'user' }
  ];

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  // Sample data - replace with your actual data
  sampleData = [
    {
      date: '02/15/2023',
      company: 'ABC Corp',
      caller: 'John D',
      campaign: 'Summer Sale',
      contact: 'Jane Smith',
      phone: '(555) 123-4567',
      dispo: 'No Answer',
      dispoTime: '10:15 AM',
      callTime: '10:10 AM',
      callLength: '00:05:23',
      status: 'Completed',
      user: 'jdoe'
    },
    // Add more sample data as needed
  ];

  // Form model
  filters = {
    dateFrom: '',
    dateTo: '',
    timeFrom: '',
    timeTo: '',
    dispo: '',
    campaign: '',
    caller: '',
    user: '',
    showAll: false,
    showOnlyMine: false
  };

  // Dropdown options
  dispoOptions = [
    { value: 'No Answer', label: 'No Answer' },
    { value: 'Busy', label: 'Busy' },
    { value: 'Disconnected', label: 'Disconnected' },
    { value: 'Left VM', label: 'Left VM' },
    { value: 'Callback', label: 'Callback' },
    { value: 'Not Interested', label: 'Not Interested' },
    { value: 'Sale', label: 'Sale' },
    { value: 'Do Not Call', label: 'Do Not Call' },
    { value: 'Wrong Number', label: 'Wrong Number' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Not in Service', label: 'Not in Service' },
    { value: 'All', label: 'All' }
  ];

  campaignOptions = [
    { value: 'Summer Sale', label: 'Summer Sale' },
    { value: 'Winter Special', label: 'Winter Special' },
    { value: 'New Year', label: 'New Year' },
    { value: 'All', label: 'All' }
  ];

  callerOptions = [
    { value: 'John D', label: 'John D' },
    { value: 'Jane S', label: 'Jane S' },
    { value: 'Mike J', label: 'Mike J' },
    { value: 'All', label: 'All' }
  ];

  userOptions = [
    { value: 'jdoe', label: 'John Doe' },
    { value: 'jsmith', label: 'Jane Smith' },
    { value: 'mjohnson', label: 'Mike Johnson' },
    { value: 'All', label: 'All' }
  ];

  constructor() { }

  ngOnInit() {
    // Load your data here
    this.rows = this.sampleData;
    this.temp = [...this.sampleData];

    // Set default date to today
    const today = new Date().toISOString().split('T')[0];
    this.filters.dateFrom = today;
    this.filters.dateTo = today;
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // Filter our data
    const temp = this.temp.filter(function(d) {
      return d.company.toLowerCase().indexOf(val) !== -1 ||
             d.caller.toLowerCase().indexOf(val) !== -1 ||
             d.campaign.toLowerCase().indexOf(val) !== -1 ||
             d.contact.toLowerCase().indexOf(val) !== -1 ||
             d.phone.toLowerCase().indexOf(val) !== -1 ||
             d.dispo.toLowerCase().indexOf(val) !== -1 ||
             d.user.toLowerCase().indexOf(val) !== -1 ||
             !val;
    });

    // Update the rows
    this.rows = temp;
  }

  onSearch() { }

  onReset() {
    // Reset all filters
    const today = new Date().toISOString().split('T')[0];
    this.filters = {
      dateFrom: today,
      dateTo: today,
      timeFrom: '',
      timeTo: '',
      dispo: '',
      campaign: '',
      caller: '',
      user: '',
      showAll: false,
      showOnlyMine: false
    };

    // Reset table data
    this.rows = [...this.temp];
  }
}
